import React, { useState, useEffect, useContext } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { pexios, toast } from '../../utils/functions';
import { history } from '../../utils/variables';
import Pricing from '../../components/expert/Pricing';
import Calculator from '../../components/expert/Calculator';
import Modal from "../../components/master/Modal";
import { useTranslation } from 'react-i18next';
import { TitleContext } from '../../App';

export default function EditReport() {

    const { id } = useSelector(store => store.routerData);
    const { user } = useSelector(store => store);

    const [fixCar, setFixCar] = useState(false);
    const { t } = useTranslation();
    const { type } = useParams();
    /////
    const [report,setReport] = useState({});
    const [recomPrice,setRecomPrice] =useState({
        accessories: '',
        wages: '',
    });

    const [items, setItems] = useState({
        accessories: [],
        wages: [],
        extras: [],
        deducts: [],
    });
    const [selectedItems, setSelectedItems] = useState({
        accessories: [],
        wages: [],
        extras: [],
        deducts: [],
    });
    const [loading, setLoading] = useState(true);
    const [buttonLoader, setButtonLoader] = useState(false);
    const [isModalOpened, setIsModalOpened] = useState(false);
    // const {setTitle} = useContext(TitleContext)
    // useEffect(()=>{
    //     setTitle(t('Edit file'))
    // },[])

    useEffect(() => {
        pexios('api/get_report_option')
            .then(res => {
                setItems({
                    accessories: res.data.accessories,
                    wages: res.data.wages,
                    extras: res.data.extras,
                    deducts: res.data.deducts,
                })
            });
        pexios('api/v2/get_report_by_id','post',{ id })
            .then(res => {
                const report = res.data.data;
                ///
                setReport(res.data.data)

                let insurance_type = report.accident.insurance_type;
                if ((insurance_type === 'body' && report.culprit.car.car_type_id === 1) ||
                    (insurance_type === 'third' && report.losses.type==='car' && report.losses.car.car_type_id === 1))
                    setFixCar(true);


                setSelectedItems({
                    accessories: JSON.parse(report.accessories),
                    wages: JSON.parse(report.wages),
                    extras: JSON.parse(report.extras),
                    deducts: JSON.parse(report.deducts),
                });
            });
    }, [id, type]);


    //////
    useEffect(()=>{
        if(items.accessories.length){
            setLoading(false)
        }
    },[items])
    function getPrice (id,type){
        if(report &&['accessories','wages'].includes(type) && fixCar){
            let info ={
                carInfo:'',
                insuranceType: report.accident.insurance_type,
                title: type,
                id: id
            }
            let insurance_type = report.accident.insurance_type;
            if(insurance_type === 'body') info = {...info,carInfo:report.culprit.car}
            else info ={...info,carInfo: report.losses.car};
             pexios('api/get_recommended_price','post', info)
                .then( res=>{
                    setRecomPrice(prevState => ({
                        ...prevState,
                        [type]: res.data
                    }));
                })
        }
    }

    function submitValue(type, data) {
        setSelectedItems(prevState => ({
           ...prevState,
            [type]: data,
        }));
    }
    function submitPrice(isFinished) {
        setButtonLoader(true);
        const data={
            report_id: id,
            accessory: JSON.stringify(selectedItems.accessories),
            wage: JSON.stringify(selectedItems.wages),
            deduct: JSON.stringify(selectedItems.deducts),
            extra: JSON.stringify(selectedItems.extras),
            isFinished,
        };
        pexios(`api/${type === 'double' ? 'add_double_review' : 'update_report'}`, 'post', data)
            .then(() => {
                toast(t('File edited successfully'));
                setTimeout(() => {
                    history.replace('/report-single');
                }, 5000);
            });
    }

    return (
        <div className='content final-pricing'>
            <Modal visible={isModalOpened}>
                <div className='modal-content text-center p10'>
                    <p className='title'>
                        {t('Does your experting complete?')}
                    </p>
                    {user.data.company !== 0 &&
                    <button
                        className='btn btn-circle btn-green btn-block mt20'
                        disabled={buttonLoader && 'disabled'}
                        onClick={() => submitPrice(1)}
                    >
                        {
                            buttonLoader ?
                                <i className='fas fa-spinner fa-spin' /> :
                                t('Yes,deliver')
                        }
                    </button>
                    }
                    {user.data.company === 0 && 
                    <>
                    <button
                        className='btn btn-circle btn-green btn-block mt10'
                        disabled={buttonLoader && 'disabled'}
                        onClick={() => submitPrice(1)}
                    >
                        {
                            buttonLoader ?
                                <i className='fas fa-spinner fa-spin' /> :
                                'بله، پرونده" تایید شده" ارسال شود'
                        }
                    </button>
                    <button
                        className='btn btn-circle btn-red btn-block mt10'
                        disabled={buttonLoader && 'disabled'}
                        onClick={() => submitPrice(2)}
                    >
                        {
                            buttonLoader ?
                                <i className='fas fa-spinner fa-spin' /> :
                                'بله، پرونده "رد شده" ارسال شود'
                        }
                    </button>
                    <button
                        className='btn btn-circle btn-dark-blue btn-block mt10'
                        disabled={buttonLoader && 'disabled'}
                        onClick={() => submitPrice(22)}
                    >
                        {
                            buttonLoader ?
                                <i className='fas fa-spinner fa-spin' /> :
                                'بله، پرونده "بیش از تعهد من" ارسال شود'
                        }
                    </button>
                    </>
                    }
                    <button
                        className='btn btn-circle btn-blue btn-block mt10'
                        disabled={buttonLoader && 'disabled'}
                        onClick={() => submitPrice(0)}
                    >
                        {
                            buttonLoader ?
                                <i className='fas fa-spinner fa-spin' /> :
                                t('No, i need time')
                        }
                    </button>
                </div>
            </Modal>
            {loading?
                <Modal visible={loading}>
                    <div className='loader-modal'>
                        <i className='fas fa-spinner fa-spin'/>
                    </div>
                </Modal>
                :
                <>
                    <h4 className='mt20'>
                        {t('Edit file')}
                    </h4>
                    <Pricing
                        title={t('Accessories list')}
                        placeholder={t('Accessory title')}
                        pickerData={items.accessories}
                        submit={(value) => submitValue('accessories', value)}
                        value={selectedItems.accessories}
                        fixItem={fixCar}
                        getPrice={(id)=>getPrice(id,'accessories')}
                        recomPrice={recomPrice.accessories}
                    />
                    <Pricing
                        title={t('Wage list')}
                        placeholder={t('Wage title')}
                        pickerData={items.wages}
                        submit={(value) => submitValue('wages', value)}
                        value={selectedItems.wages}
                        fixItem={fixCar}
                        getPrice={(id)=>getPrice(id,'wages')}
                        recomPrice={recomPrice.wages}
                    />
                    <Pricing
                        title={t('Extra list')}
                        placeholder={t('Extra title')}
                        pickerData={items.extras}
                        submit={(value) => submitValue('extras', value)}
                        value={selectedItems.extras}
                        fixItem={false}
                    />
                    <Pricing
                        title={t('Deduct list')}
                        placeholder={t('Deduction title')}
                        pickerData={items.deducts}
                        submit={(value) => submitValue('deducts', value)}
                        value={selectedItems.deducts}
                        fixItem={false}
                    />
                    <Calculator
                        accessories={selectedItems.accessories}
                        wages={selectedItems.wages}
                        extras={selectedItems.extras}
                        deducts={selectedItems.deducts}
                    />
                    <button
                        className='btn btn-block btn-white-purple btn-circle mt20 w-50 m-auto'
                        disabled={buttonLoader}
                        onClick={() => type !== 'double' ? setIsModalOpened(true) : submitPrice(true)}
                    >
                        {
                            buttonLoader ?
                                <i className='fas fa-spinner fa-spin' /> :
                                t('Final confirm')
                        }
                    </button>
                </>
            }

        </div>
    );

}
